module.exports = __webpack_public_path__ + "media/3_2-7.4f521556.mp3";